import { render, staticRenderFns } from "./MobileAnswerCard.vue?vue&type=template&id=38316ec2&"
import script from "./MobileAnswerCard.vue?vue&type=script&lang=js&"
export * from "./MobileAnswerCard.vue?vue&type=script&lang=js&"
import style0 from "./MobileAnswerCard.vue?vue&type=style&index=0&id=38316ec2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports